export default "__VITE_ASSET__DlaRQoSs__"